import React, { Component } from "react";
import Image from '../global/Image';

export default class PageTeam extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--text-space c-page__block--top-' + block.top_space + ' c-page__block--bottom-' + block.bottom_space + ' scope-' + block.background_colour}>
			    			    		
		    		<div className="c-page__block__inner">
			    			
		    			<div className="c-team">
		    				{block.src &&
			    				<div className="c-team__image">
			    					<Image src={block.src} srcset={block.srcset} />
			    				</div>
		    				}
		    				{block.svg_logo && block.logo_url && block.logo_width &&
			    				<a href={block.logo_url} className="c-team__logo" target="_blank" dangerouslySetInnerHTML={{__html:block.svg_logo}} style={{maxWidth:(parseInt(block.logo_width) / 16) +'rem'}}></a>
		    				}
		    				<div className="scope-text scope-text--small" dangerouslySetInnerHTML={{__html:block.text}}></div>
		    			</div>
																    			
		    		</div>
			    					    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
